import { Loader } from "@circle-react-uikit/Loader";

export const RailBar = () => <Loader center />;
